import * as angular from "angular";

angular
  .module('bringoz.admin.organizations', [
    'bringoz.admin.commons',
    'bringoz.admin.iam'
  ]);
